import { Check } from "lucide-react";

interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export default function ProgressIndicator({ currentStep, totalSteps }: ProgressIndicatorProps) {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  return (
    <div className="w-full max-w-2xl mx-auto mb-8">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <div key={step} className="flex items-center flex-1">
            {/* Step Circle */}
            <div className="relative flex flex-col items-center">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-all duration-300 ${
                  step < currentStep
                    ? "bg-cyan text-deep-navy"
                    : step === currentStep
                    ? "bg-cyan text-deep-navy ring-4 ring-cyan/20"
                    : "bg-dark-card text-medium-gray border-2 border-medium-gray/30"
                }`}
              >
                {step < currentStep ? (
                  <Check className="w-5 h-5" />
                ) : (
                  <span>{step}</span>
                )}
              </div>
              
              {/* Step Label */}
              <span
                className={`absolute -bottom-6 text-xs font-medium whitespace-nowrap transition-colors duration-300 ${
                  step <= currentStep ? "text-cyan" : "text-medium-gray"
                }`}
              >
                Step {step}
              </span>
            </div>

            {/* Connector Line */}
            {index < steps.length - 1 && (
              <div className="flex-1 h-1 mx-2">
                <div
                  className={`h-full rounded transition-all duration-300 ${
                    step < currentStep
                      ? "bg-cyan"
                      : "bg-medium-gray/20"
                  }`}
                />
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Progress Text */}
      <div className="text-center mt-10 text-sm text-medium-gray">
        Step {currentStep} of {totalSteps}
      </div>
    </div>
  );
}
